import styled, { css } from 'styled-components';
import { primaryColor, sidebarWidth } from '../../../src/pages/dash/styles'; 

export const SidebarContainer = styled.div`
  width: ${sidebarWidth};
  min-width: ${sidebarWidth};
  background-color: #FFFFFF;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.05);
  display: flex;
  flex-direction: column;
  padding-bottom: 20px;
  position: sticky;
  top: 0;
  height: 100vh;
`;

export const LogoSection = styled.div`
  display: flex;
  align-items: center;
  padding: 20px 30px;
  border-bottom: 1px solid #EBEEF2;
  margin-bottom: 20px;
  height: 125px;
`;

export const LogoIcon = styled.div`
  width: 45px;
  height: 45px;
  background: linear-gradient(to right, #4F46E5, #06B6D4);
  border-radius: 6px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #FFFFFF;
  font-weight: bold;
`;

export const Img = styled.img``;

export const LogoText = styled.div`
  line-height: 1.2;
  h2 {
    font-size: 20px;
    font-weight: 700;
    color: #333333;
    margin: 0;
  }
  span {
    font-size: 14px;
    font-weight: 400;
    color: #888888;
  }
`;

export const NavList = styled.nav`
  flex-grow: 1;
  padding: 0 10px;
`;

const navItemActive = css`
  background-color: ${primaryColor};
  color: #FFFFFF;
  font-weight: 600;
  border-radius: 8px;
  height: 72px;
`;

export const NavItem = styled.div`
  display: flex;
  align-items: center;
  padding: 12px 18px;
  cursor: pointer;
  color: #566474;
  font-size: 16px;
  font-weight: 700;
  margin: 5px 0;
  transition: all 0.2s;
  height: 72px;

  &:hover {
    background-color: #F0F5FF;
    color: ${primaryColor};
    border-radius: 8px;
  }

  ${props => props.active && navItemActive}
`;

export const NavIcon = styled.div`
  width: 20px;
  height: 20px;
  margin-right: 15px;
  background-color: transparent;
  color: ${props => props.active ? '#E5E7EB' : '#566474'};
  font-size: 18px;

  img {
    width: 20px;
    height: 20px;
  }
`;

/* ====================== BOTÃO DE LOGOUT ====================== */
export const UserSection = styled.div`
  margin-top: auto; /* empurra para a parte inferior */
  padding: 20px;
`;

export const LogoutButton = styled.button`
  width: 100%; /* ocupa toda a largura */
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background-color: #D32F2F; /* vermelho */
  color: #fff;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  cursor: pointer;
  font-weight: 600;
  font-size: 16px;
  transition: background-color 0.2s;

  &:hover {
    background-color: #b22a2a; /* hover vermelho escuro */
  }
`;
